import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { css } from "@linaria/core";
import React, { useCallback } from "react";
import { INSERT_EQUATION_COMMAND, InsertEquationDialog } from "../plugins/EquationPlugin";
import { isSelectionInTable } from "../../../utils/isSelectionInTable";
import { ToolbarButton } from "../../../Toolbar/ToolbarButton";
import { Formula } from "../../../../IconV2/react";
import Modal from "../../../../Modal";
import ModalForm from "../../../../Modal/Form";
import t from "../../../../i18n";

const equationToolbarModalForm = css`
  overflow: hidden;
`;
export function EquationToolbarButton() {
  const [editor] = useLexicalComposerContext();
  const [isTableSelection, setIsTableSelection] = React.useState(false);

  const [isEquationEditorOpen, setIsEquationDialogOpen] = React.useState(false);
  const [equation, setEquation] = React.useState<string | null>(null);
  const [inline, setInline] = React.useState<boolean>(true);
  const openEquationEditor = useCallback(() => setIsEquationDialogOpen(true), []);
  const closeEquationEditor = useCallback(() => {
    setIsEquationDialogOpen(false);
    setEquation(null);
  }, []);

  const onEquation = useCallback((equation: string, inline: boolean) => {
    setEquation(equation);
    setInline(inline);
  }, []);

  const onEquationInsert = useCallback(() => {
    editor.dispatchCommand(INSERT_EQUATION_COMMAND, { equation: equation!, inline });
    return true;
  }, [editor, equation, inline]);

  React.useEffect(
    () =>
      editor.registerUpdateListener(({ editorState }) => {
        editorState.read(() => setIsTableSelection(isSelectionInTable()));
      }),
    [editor],
  );

  return (
    <>
      <ToolbarButton
        description={
          isTableSelection
            ? t("markdown_editor.plugin.equation.insert.disable")
            : t("markdown_editor.plugin.equation.insert")
        }
        onClick={openEquationEditor}
        disabled={isTableSelection}
      >
        <Formula />
      </ToolbarButton>
      <Modal
        title={t("markdown_editor.plugin.equation.insert")}
        isOpen={isEquationEditorOpen}
        onRequestClose={closeEquationEditor}
        size="l"
      >
        <ModalForm
          onSubmit={equation && equation.trim() !== "" ? () => onEquationInsert() : false}
          onRequestClose={closeEquationEditor}
          className={equationToolbarModalForm}
          okButtonName={t("markdown_editor.plugin.equation.insert_short")}
        >
          <InsertEquationDialog onEquation={onEquation} />
        </ModalForm>
      </Modal>
    </>
  );
}
